module.exports = "/_next/static/images/8280391b7f77e7832d6edc4564338a8d-hick@3x.png";